import React, { useEffect, useState } from "react";
import EmailVerify from "./Components/Dashbord/EmailVerify";
import Doctors from "./Components/MySavedItems/Doctors";
import Pharmacies from "./Components/MySavedItems/Pharmacies";

const PharmacyMySavedItems = () => {
    const [userdata, setUserdata] = useState({});
    const [tabsest, setTabseset] = useState("Doctors");

    useEffect(() => {
        const userData = localStorage.getItem("userData");
        if (userData) {
            setUserdata(userData);
        }
    }, []);

    return (
        <>
            <div className="subbody" style={{ width: '100%', padding: '2% 4%' }}>
                {userdata.activation_key == null && (
                    <EmailVerify />
                )}

                <section className="dc-haslayout dc-dbsectionspace">
                    <div className="row">
                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-9">
                            <form className="dc-user-account" method="post">
                                <div className="dc-dashboardbox dc-dashboardtabsholder dc-accountsettingholder">
                                    <div className="dc-dashboardtabs">
                                        <ul className="dc-tabstitle nav navbar-nav">
                                            <li className="nav-item">
                                                <a className={`${tabsest == "Doctors" ? 'active' : ''} `} href="#" onClick={() => setTabseset("Doctors")}>
                                                    Doctors
                                                </a>
                                            </li>
                                            <li className="nav-item">
                                                <a className={`${tabsest == "Pharmacies" ? 'active' : ''} `} href="#" onClick={() => setTabseset("Pharmacies")}>
                                                    Pharmacies
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                    {tabsest == "Doctors" && (
                                        <Doctors/>
                                    )}
                                    {tabsest == "Pharmacies" && (
                                        <Pharmacies/>
                                    )}
                                </div>
                            </form>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default PharmacyMySavedItems;


